export default __webpack_public_path__ + "static/media/laundry1-beforeA-2048w.51d8bb29.png";